/**
 * @generated SignedSource<<33de0ecc9919114a701fc0135c4d6f1e>>
 * @relayHash e24b0da0f9667d2c9d18dd27b057b166
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 429cf356462ed5a82d27ab42cba9744a88f0cec50846d920caf9b5b4097bc6a9

import type { ConcreteRequest } from 'relay-runtime';
export type StudioBuildState = "FAILED" | "IN_PROGRESS" | "SUCCESS" | "WAITING" | "%future added value";
export type StudioBuildType = "AUTOMATION_RULE" | "ECOSYSTEM_APP" | "ROVO_AGENT" | "%future added value";
export type StudioCreateDraftBuildInput = {
  buildNumber: number;
  solutionId: string;
  solutionVersion: number;
  workspaceId: string;
};
export type useHandoffAction_planBuildMutation$variables = {
  input: StudioCreateDraftBuildInput;
  skip: boolean;
};
export type useHandoffAction_planBuildMutation$data = {
  readonly studio_createDraftBuild?: {
    readonly build: {
      readonly ari: string | null;
      readonly buildId: string | null;
      readonly state: StudioBuildState | null;
      readonly type: StudioBuildType | null;
    } | null;
  } | null;
};
export type useHandoffAction_planBuildMutation = {
  response: useHandoffAction_planBuildMutation$data;
  variables: useHandoffAction_planBuildMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "StudioCreateDraftBuildPayload",
        "kind": "LinkedField",
        "name": "studio_createDraftBuild",
        "plural": false,
        "selections": [
          {
            "concreteType": "StudioCreateDraftBuildDetails",
            "kind": "LinkedField",
            "name": "build",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "ari"
              },
              {
                "kind": "ScalarField",
                "name": "buildId"
              },
              {
                "kind": "ScalarField",
                "name": "state"
              },
              {
                "kind": "ScalarField",
                "name": "type"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useHandoffAction_planBuildMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useHandoffAction_planBuildMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "429cf356462ed5a82d27ab42cba9744a88f0cec50846d920caf9b5b4097bc6a9",
    "metadata": {},
    "name": "useHandoffAction_planBuildMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "68a9e008c5970ab00f32a54d7ac2706c";

export default node;
